import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Dialog, DialogStyle } from 'primeng/dialog';
import { NgClass } from '@angular/common';
import { PrimeTemplate } from 'primeng/api';
import { MButtonComponent } from '../m-button/m-button.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-modal',
  templateUrl: './m-modal.component.html',
  styleUrls: ['./m-modal.component.scss'],
  providers: [DialogStyle],
  imports: [Dialog, NgClass, PrimeTemplate, MButtonComponent]
})
export class MModalComponent extends Dialog {
  @Input() isFullscreen = false;
  @Input() isMaximized = false;
  @Input() override showHeader = true;
  @Input() showFooter = true;

  // PrimeNG 20 applies root host class/style via `host: { '[class]': "cn(cx('root'), styleClass)", '[style]': "sx('root')" }`.
  // This wrapper extends Dialog but renders its OWN inner <p-dialog>, so that metadata is inherited
  // onto <m-modal> too — duplicating the dialog root styling on the wrapper host.
  // Neutralize on the wrapper host; the inner dialog is unaffected.
  override cx(): string {
    return '';
  }

  override sx(): { [klass: string]: unknown } | undefined {
    return undefined;
  }
}
